import { el } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

import AttendeeMode from './attendee-mode';
// import MeetingRecorder from './recorder';

class ProducerMode extends AttendeeMode {

  constructor(meeting, post) {

    super(application.getUser()._id, meeting, post);

    this.meetingRecorder = null;

    this.el = el('.producer-mode-container', [
      el('ht-spinner', { size: 'small' })
    ]);

  }

  onmount() {

    this.initialize();

  }

  onunmount() {

    this.el = null;

  }

  async initialize() {

    const controlOptions = {
      audio: true,
      video: true,
      presentScreen: true
    };

    try {

      const started = await this.startMeeting(controlOptions, false);

      if (started === false) {
        return;
      }

      // Recording disabled temporarily
      // let _handler = async function handler() {

      //   this.meetingRoom.el.removeEventListener('audio-video-did-started', _handler);

      //   const meetingAudioStream = await this.meetingSession.audioVideo.getCurrentMeetingAudioStream();
      //   const audioStreams = [meetingAudioStream, this.audioStream];

      //   this.meetingRecorder = new MeetingRecorder(this.meeting.recording, audioStreams, this.meetingRoom.stage.getCanvas());

      //   this.meetingRecorder.start();

      // }.bind(this);

      // this.meetingRoom.el.addEventListener('audio-video-did-started', _handler);

    } catch (exception) {
      // eslint-disable-next-line no-console
      console.error(exception);
      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Unknown error! If repeated, kindly contact administration',
        seconds: 5,
        type: 'error'
      });
      application.eventSystem.internal.emit(internalEventCodes.NAVIGATE_TO, {
        to: '/community'
      });

    }

  }

  async doLeaveMeeting() {

    try {

      await serverInterface.startup.community.singleProducerMeeting.endSingleProducerMeetingByPostId(this.meeting.postId);

      return true;

    } catch (exception) {

      return false;

    }

  }

  mountNextView() {
    application.eventSystem.internal.emit(internalEventCodes.NAVIGATE_TO, {
      to: `/community/${this.post.humanFriendlyId}`
    });
  }

}

export default ProducerMode;